import React from 'react';

import storyFooter from 'src/assets/starterDashboardV2/readyToShare/storyFooter.svg';

import { FooterStyles, StoryFooterStyles } from './Footer.styles';
import type { FacebookStoryComponentsProps } from './types';

export function Footer(props: FacebookStoryComponentsProps): React.JSX.Element {
	const { size } = props;
	const styles = FooterStyles({ size });

	return (
		<div className={styles}>
			<img className={StoryFooterStyles({ size })} src={storyFooter} alt="" aria-hidden />
		</div>
	);
}
